import { Injectable } from '@angular/core';
import { ThemeService } from "../../../setting/theme/service/theme.service";
import { HostService } from '@serengeti/serengeti-resource';


@Injectable({
  providedIn: 'root'
})
export class WizardResourceStatService {

  pieColor: string;
  cpuIcon: string;
  memoryIcon: string;
  diskIcon: string;

  data = [
    {}, {}, {}
  ];

  constructor(
		private hostService: HostService,
    private themeService: ThemeService
  ) {
    this.cpuIcon = 'computer';
    this.memoryIcon = 'memory';
    this.diskIcon = 'storage';

    this.pieColor = document.documentElement.style.getPropertyValue('--fontColor');
    this.themeService.changed().subscribe(() => {
      const theme = this.themeService.getTheme();

      this.pieColor = this.themeService.getThemeColors().fontcolor;
    });
  }

  calcPercent(datum: any) {
      datum.percent = (datum.limit && datum.stats > 0 ? datum.stats / datum.limit * 100 : 0);
  }

  async getData() {
    await this.hostService.summary().toPromise().then((summaries: any) => {
      this.data.forEach((datum: any) => {
        datum.stats = 0;
        datum.limit = 0;
        datum.percent = 0;
      });

      summaries.forEach((summary: any) => {
        let datum = null;
        if (summary.type === 'VCPU') {
          datum = this.data[0];
          datum.logo = this.cpuIcon;
        } else if (summary.type === 'MEMORY') {
          datum = this.data[1];
          datum.logo = this.memoryIcon;
        } else if (summary.type === 'DISK') {
          datum = this.data[2];
          datum.logo = this.diskIcon;
        }

        if (datum) {
          datum.stats += summary.used;
          datum.limit += summary.total;
          datum.unit = summary.unit;
          this.calcPercent(datum);
        }
      });
    });

    return this.data;
  }

  getBillingPrice(instance: any) {
    if(instance.billingPrice) {
      return this.getDiffHours(new Date(), new Date(instance.createdDate)) * instance.billingPrice;
    }
    else {
      return 0;
    }
  }

  getDiffHours(dateTime2: Date, dateTime1: Date) {
    var diff =(dateTime2.getTime() - dateTime1.getTime()) / 1000;
    diff /= (60 * 60);
    return Math.abs(Math.round(diff));
  }

  filter(properties:any, name:string) {
    if(properties.filter(function(e:any) {return e.name==name})[0]) {
      return properties.filter(function(e:any) {return e.name==name})[0].value;
    }
    else {
      return 0;
    }
  }

  getConfiguration() {

    return this.data = [
      {
        color: this.pieColor,
        description: 'dashboard.items.resource-stat.cpu-summary',
        stats: 0,
        percent: 0,
        icon: this.cpuIcon,
        unit: 'EA',
        limit: 0,
        logo: this.cpuIcon
      }, {
        color: this.pieColor,
        description: 'dashboard.items.resource-stat.memory-summary',
        stats: 0,
        percent: 0,
        icon: this.memoryIcon,
        unit: 'GB',
        limit: 0,
        logo: this.memoryIcon
      }, {
        color: this.pieColor,
        description: 'dashboard.items.resource-stat.disk-summary',
        stats: 0,
        percent: 0,
        icon: this.diskIcon,
        unit: 'GB',
        limit: 0,
        logo: this.diskIcon
      }
    ];
  }
}
